function buildPagination(paginationContainer) {
  const paginationPages = document.querySelectorAll(".facetwp-page");

  const processedPages = {
    active: [],
    other: [],
    last: [],
    next: [],
    prev: [],
  };

  paginationPages.forEach((page) => {
    if (
      page.classList.contains("facetwp-page") &&
      !(
        page.classList.contains("active") ||
        page.classList.contains("last") ||
        page.classList.contains("next") ||
        page.classList.contains("prev")
      )
    ) {
      processedPages.other.push(page.outerHTML);
    } else if (page.classList.contains("active")) {
      processedPages.active.push(page.outerHTML);
    } else if (page.classList.contains("last")) {
      processedPages.last.push(page.outerHTML);
    } else if (page.classList.contains("prev")) {
      processedPages.prev.push(page.outerHTML);
    } else if (page.classList.contains("next")) {
      processedPages.next.push(page.outerHTML);
    }
  });

  const paginationLayout = `
    <div class="facetwp-custom-pager-wrapper">
        ${processedPages.prev[0] ? processedPages.prev[0] : ""}
        ${processedPages.active[0]}
        <span class="facetwp-custom-divider">/</span>

        ${processedPages.last[0] ? processedPages.last[0] : ""}
        <span class="facetwp-custom-arrow-down"></span>
        ${processedPages.next[0] ? processedPages.next[0] : ""}
    </div>
    <div class="facetwp-custom-hidden-pages">
      <div class="facetwp-custom-hidden-pages__container">
        ${processedPages.other.join(" ")}
      </div>
    </div>
  `;

  paginationContainer.innerHTML = paginationLayout;
}

window.addEventListener("load", () => {
  const paginationContainers = document.querySelectorAll(".facetwp-pager");

  if (paginationContainers.length > 0) {
    paginationContainers.forEach((paginationContainer) => {
      buildPagination(paginationContainer);
    });
  }
});

function toggleHiddenPagesVisibility(e) {
  const paginationWrapper = e.target.closest(".facetwp-pager");
  if (!paginationWrapper) return;

  const toggler = e.target.closest(".facetwp-custom-arrow-down");
  const hiddenPages = paginationWrapper.querySelector(
    ".facetwp-custom-hidden-pages"
  );

  if (toggler) {
    hiddenPages.classList.toggle("visible");
    return;
  } else {
    hiddenPages.classList.remove("visible");
  }
}

window.addEventListener("facetwp-loaded", () => {
  const paginationContainers = document.querySelectorAll(".facetwp-pager");

  if (paginationContainers.length > 0) {
    paginationContainers.forEach((paginationContainer) => {
      buildPagination(paginationContainer);
    });
  }
});

window.addEventListener("click", (e) => {
  toggleHiddenPagesVisibility(e);
});
